/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TeamInputs */

const th_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const ja_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const pt_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const id_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe`)
};

const tl_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const vi_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const ru_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда`)
};

const tr_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım`)
};

const it_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra`)
};

const pl_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyna`)
};

const uk_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда`)
};

const hi_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम`)
};

const ar_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفريق`)
};

const ms_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم`)
};

const fa_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم`)
};

const sw_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_team = /** @type {(inputs: TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team = /** @type {((inputs?: TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team(inputs)
	if (locale === "ja") return ja_team(inputs)
	if (locale === "zh") return zh_team(inputs)
	if (locale === "es") return es_team(inputs)
	if (locale === "pt") return pt_team(inputs)
	if (locale === "id") return id_team(inputs)
	if (locale === "fr") return fr_team(inputs)
	if (locale === "tl") return tl_team(inputs)
	if (locale === "vi") return vi_team(inputs)
	if (locale === "ko") return ko_team(inputs)
	if (locale === "de") return de_team(inputs)
	if (locale === "ru") return ru_team(inputs)
	if (locale === "tr") return tr_team(inputs)
	if (locale === "it") return it_team(inputs)
	if (locale === "pl") return pl_team(inputs)
	if (locale === "uk") return uk_team(inputs)
	if (locale === "hi") return hi_team(inputs)
	if (locale === "ar") return ar_team(inputs)
	if (locale === "ms") return ms_team(inputs)
	if (locale === "bn") return bn_team(inputs)
	if (locale === "zh-TW") return zh_tw2_team(inputs)
	if (locale === "zh-HK") return zh_hk2_team(inputs)
	if (locale === "ur") return ur_team(inputs)
	if (locale === "fa") return fa_team(inputs)
	if (locale === "sw") return sw_team(inputs)
	if (locale === "nl") return nl_team(inputs)
	return en_team(inputs)
});